import React from 'react';
export const CmsContext = React.createContext({});
